import React from 'react'
import { Card } from '@sainsburys-tech/luna-card'
import { Container } from '@sainsburys-tech/luna-react'
import { Display4 } from '@sainsburys-tech/luna-typography'

const Unauthorised = () => {
  return (
    <Container className='container'>
      <Card className='main-content'>
        <Display4>You don't have the required access to visit this site.</Display4>
      </Card>
    </Container>
  )
}

export default Unauthorised
